var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecord = function SvgRecord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.957 6.24366C30.957 2.79537 27.8189 0 23.9479 0C20.0768 0 16.9388 2.79537 16.9388 6.24366H7.65199C3.90087 6.24366 2.24677 7.40372 2.24677 7.40372C2.24677 7.40372 0.396305 8.32488 0.12194 11.696C-0.152425 15.0672 0.12194 55.846 0.12194 55.846C0.12194 55.846 0.12194 60.0085 1.5344 61.4373C3.38166 63.3059 4.11499 63.3943 7.29635 63.7779L7.65199 63.8208H35.0805C36.0408 63.8208 36.9074 63.8719 37.7146 63.9195L37.7154 63.9196C40.327 64.0737 42.3164 64.1912 44.8429 62.4214C46.2477 61.4373 47.4159 58.9868 47.4159 56.9078L48 13.5279C48 10.753 47.257 9.45119 45.6596 7.89777C44.125 6.40528 42.4511 6.24366 40.7753 6.24366H30.957ZM26.2842 7.63116C26.2842 9.16373 25.2382 10.4061 23.9478 10.4061C22.6575 10.4061 21.6115 9.16373 21.6115 7.63116C21.6115 6.09859 22.6575 4.8562 23.9478 4.8562C25.2382 4.8562 26.2842 6.09859 26.2842 7.63116ZM37.9661 22.8934V18.0372H9.92958V22.8934H37.9661ZM37.9661 31.2183V36.0744H9.92958V31.2183H37.9661ZM33.2934 49.2555V44.3994H9.92958V49.2555H33.2934Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/record.606081e9.svg";
export { ForwardRef as ReactComponent };